import BaseStore from "@/stateManagement/BaseStore";
import { StoreConfig } from "@datorama/akita";
import { singleton } from "tsyringe";

import type { CustomerDelayedRewardsEntity } from "../models/RewardsCustomerRewardsEntities";

export interface CustomerDelayedRewardsState {
    customerDelayedRewardsList: CustomerDelayedRewardsEntity[];
}

const createInitialState = (): CustomerDelayedRewardsState => ({
    customerDelayedRewardsList: [],
});

@singleton()
@StoreConfig({ name: "RewardsCustomerDelayedRewardsStore" })
class RewardsCustomerDelayedRewardsStore extends BaseStore<CustomerDelayedRewardsState> {
    constructor() {
        super(createInitialState());
    }
}

export default RewardsCustomerDelayedRewardsStore;
